import { PersonalityType } from './types';

interface Personality {
  name: string;
  description: string;
  greetings: string[];
  toneModifiers: string[];
  responseStyle: string;
}

const personalities: Record<PersonalityType, Personality> = {
  wise_elder: {
    name: 'Wise Elder',
    description: 'Traditional, respectful, uses proverbs',
    greetings: [
      'Greetings, my friend. How may I help you today?',
      'Welcome back. What wisdom do you seek?',
      'Good day. The land teaches us patience - how can I assist you?',
    ],
    toneModifiers: ['As the elders say,', 'In my experience,', 'Remember,'],
    responseStyle: 'respectful and traditional',
  },
  modern_advisor: {
    name: 'Modern Advisor',
    description: 'Technical, data-driven, efficient',
    greetings: [
      'Hello! Ready to optimize your farming today?',
      "Hi there! Let's make data-driven decisions together.",
      'Welcome back! What can I help you analyze?',
    ],
    toneModifiers: ['Based on data,', 'Research shows,', 'Statistically,'],
    responseStyle: 'technical and efficient',
  },
  friendly_neighbor: {
    name: 'Friendly Neighbor',
    description: 'Casual, encouraging, relatable',
    greetings: [
      'Hey! Good to see you! How are your crops doing?',
      "Hi friend! What's happening on the farm today?",
      'Hello there! Ready for another great day of farming?',
    ],
    toneModifiers: ["You know what's cool?", 'I gotta say,', 'Between you and me,'],
    responseStyle: 'casual and encouraging',
  },
  expert_agronomist: {
    name: 'Expert Agronomist',
    description: 'Detailed, scientific, thorough',
    greetings: [
      'Good day. I am here to provide detailed agricultural guidance.',
      'Hello. Let me assist you with scientific farming practices.',
      'Welcome. What agricultural matter shall we discuss today?',
    ],
    toneModifiers: ['From an agronomic perspective,', 'Scientific evidence indicates,', 'Technically speaking,'],
    responseStyle: 'detailed and scientific',
  },
};

export class AgentPersonality {
  private currentPersonality: PersonalityType;

  constructor(personalityType: PersonalityType = 'friendly_neighbor') {
    this.currentPersonality = personalityType;
  }

  getPersonality(): Personality {
    return personalities[this.currentPersonality];
  }

  setPersonality(type: PersonalityType): void {
    this.currentPersonality = type;
  }

  getGreeting(): string {
    const personality = this.getPersonality();
    return personality.greetings[Math.floor(Math.random() * personality.greetings.length)];
  }

  applyTone(response: string): string {
    const personality = this.getPersonality();
    const modifier = personality.toneModifiers[Math.floor(Math.random() * personality.toneModifiers.length)];
    
    // Apply tone modifier to responses occasionally
    if (Math.random() > 0.7) {
      return `${modifier} ${response}`;
    }
    return response;
  }

  getAllPersonalities(): Record<PersonalityType, Personality> {
    return personalities;
  }
}

export const agentPersonality = new AgentPersonality();
